import { useEffect, useState } from "react";
import bundledSourceFavicons from "../data/sourceFavicons.json";
import { buildPublicAssetUrl, getPublicAssetBasePath } from "../utils/appPath";
import { normalizeSourceName } from "../utils/sourceModel";

const normalizeAssetUrl = (url, basePath) => {
  if (!url) return url;
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:")) return url;

  const cleanBase = basePath.replace(/\/$/, "");
  const cleanUrl = String(url).replace(/^\.\//, "").replace(/^\//, "");
  return `${cleanBase}/${cleanUrl}`;
};

const normalizeFaviconMap = (favicons, basePath) => {
  return Object.fromEntries(
    Object.entries(favicons || {}).map(([source, url]) => [
      normalizeSourceName(source),
      normalizeAssetUrl(url, basePath),
    ])
  );
};

const getInitialFaviconMap = () => {
  return normalizeFaviconMap(
    bundledSourceFavicons,
    getPublicAssetBasePath()
  );
};

export const useFavicons = () => {
  const [favicons, setFavicons] = useState(
    getInitialFaviconMap
  );

  useEffect(() => {
    const controller = new AbortController();

    const fetchFavicons = async () => {
      try {
        const basePath = getPublicAssetBasePath();
        const response = await fetch(buildPublicAssetUrl("source_favicons.json"), {
          signal: controller.signal,
        });

        if (!response.ok) return;

        const data = await response.json();
        setFavicons(normalizeFaviconMap(data, basePath));
      } catch (error) {
        if (error?.name !== "AbortError") console.error(error);
      }
    };

    fetchFavicons();

    return () => controller.abort();
  }, []);

  return favicons;
};
